var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div feature-flag-overrides=\"feature-flag-overrides\"></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/configs/featureFlags/featureFlags.config.jade
 ** module id = 569
 ** module chunks = 0
 **/